<template>
	<div>
		<div class="wrap-navigate">
			<div class="avatar-div">
				<avtarInput :avatar="avatar"></avtarInput>
				<div class="name">{{ profileUser.display_name }}</div>
				<div class="wrap-tooltip">
					<div
						class="edit-profile notification"
						id="adminProfile"
						@click="clickNavigate('ads-admin-profile')"
						v-bind:class="{ active: isActive == 'Profile' }"
					>
						<EditIcon />
					</div>

					<div
						class="logout"
						v-b-tooltip.hover
						:title="$t('userDashboard.navigation.logout')"
						id="logout"
						@click="userLogout"
					>
						<LogoutIcon />
					</div>
				</div>
			</div>
			<div class="navigate">
				<div
					@click="clickNavigate('add-customer')"
					id="adminDashboard"
					class="navigate-item"
					v-bind:class="{ active: isActive == 'AdsAddCustomer' }"
				>
					<div class="menu-icon">
						<UserIcon />
					</div>
					<div class="menu-item">
						{{$t('customer list')}}
					</div>
				</div>
				<div
					@click="clickNavigate('create-ads', 'homepage')"
					id="adminDashboard"
					class="navigate-item"
					v-bind:class="{ active: isActive == 'homepage' }"
				>
					<div class="menu-icon">
						<IconLaptop />
					</div>
					<div class="menu-item">
						{{$t('home page')}}
					</div>
				</div>
				<span>
					<div
						v-b-toggle.marketPlaceSearch
						class="navigate-item"
						id="adminDashboard"
					>
						<div class="menu-icon">
							<IconShop />
						</div>
						<div class="menu-item">
							{{$t('housing')}}
						</div>
						<span class="when-opened" style="margin-left:95px;">
							<ChevronUpIcon />
						</span>
						<span class="when-closed" style="margin-left:95px;">
							<ChevronDownIcon />
						</span>
					</div>
					<b-collapse
						id="marketPlaceSearch"
						accordion="my-accordion"
						role="tabpanel"
					>
						<div
							@click="clickNavigate('create-ads', 'marketPlaceSearch')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'marketPlaceSearch' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">> {{ $t('search.search') }}</div>
						</div>
						<div
							@click="clickNavigate('create-ads', 'marketPlaceListingDetails')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'marketPlaceListingDetails' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">
								{{$t('Announcement details')}}
							</div>
						</div>
					</b-collapse>
				</span>
				<span>
					<div
						v-b-toggle.realEstateSearch
						class="navigate-item"
						id="adminDashboard"
					>
						<div class="menu-icon">
							<IconHome />
						</div>
						<div class="menu-item">
							{{$t('commercial')}}
						</div>
						<span class="when-opened" style="margin-left:90px;">
							<ChevronUpIcon />
						</span>
						<span class="when-closed" style="margin-left:90px;">
							<ChevronDownIcon />
						</span>
					</div>
					<b-collapse
						id="realEstateSearch"
						accordion="my-accordion"
						role="tabpanel"
					>
						<div
							@click="clickNavigate('create-ads', 'realEstateSearch')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'realEstateSearch' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">> {{ $t('search.search') }}</div>
						</div>
						<div
							@click="clickNavigate('create-ads', 'realEstateListingDetails')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'realEstateListingDetails' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">
								{{$t('Announcement details')}}
							</div>
						</div>
					</b-collapse>
				</span>
				<span>
					<div
						v-b-toggle.engineSearch
						class="navigate-item"
						id="adminDashboard"
					>
						<div class="menu-icon">
							<IconCommute />
						</div>
						<div class="menu-item">
							{{$t('land')}}
						</div>
						<span class="when-opened" style="margin-left: 123px;">
							<ChevronUpIcon />
						</span>
						<span class="when-closed" style="margin-left: 123px;">
							<ChevronDownIcon />
						</span>
					</div>
					<b-collapse
						id="engineSearch"
						accordion="my-accordion"
						role="tabpanel"
					>
						<div
							@click="clickNavigate('create-ads', 'vehicleSearch')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'vehicleSearch' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">> {{ $t('search.search') }}</div>
						</div>
						<div
							@click="clickNavigate('create-ads', 'vehicleListingDetails')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'vehicleListingDetails' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">
								{{$t('Announcement details')}}
							</div>
						</div>
					</b-collapse>
				</span>
				<span>
					<div v-b-toggle.jobSearch class="navigate-item" id="adminDashboard">
						<div class="menu-icon">
							<IconClipboardText />
						</div>
						<div class="menu-item">
							{{$t('new project')}}
						</div>
						<span class="when-opened" style="margin-left:78px;">
							<ChevronUpIcon />
						</span>
						<span class="when-closed" style="margin-left:78px;">
							<ChevronDownIcon />
						</span>
					</div>
					<b-collapse id="jobSearch" accordion="my-accordion" role="tabpanel">
						<div
							@click="clickNavigate('create-ads', 'jobSearch')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'jobSearch' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">> {{ $t('search.search') }}</div>
						</div>
						<div
							@click="clickNavigate('create-ads', 'jobListingDetails')"
							id="adminDashboard"
							class="navigate-item"
							v-bind:class="{ active: isActive == 'jobListingDetails' }"
						>
							<div class="menu-icon"></div>
							<div class="menu-item">
								{{$t('Announcement details')}}
							</div>
						</div>
					</b-collapse>
				</span>
			</div>
		</div>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations, mapGetters } from 'vuex';
//import PencilOutlinedIcon from "vue-material-design-icons/PencilOutline.vue";
import EditIcon from '@/components/icons/IconEdit/index';
import LogoutIcon from '@/components/icons/IconLogout/index';
import IconLaptop from '@/components/icons/IconLaptop/index';
import IconShop from '@/components/icons/IconShop/index';
import IconHome from '@/components/icons/IconHome/index';
import IconCommute from '@/components/icons/IconCommute/index';
import IconClipboardText from '@/components/icons/IconClipboardText/index';
import UserIcon from '@/components/icons/IconUser/index';
import { SHOW_REJECT_ACCEPT_BUTTON } from '@/controllers/ActionTypes';
import avtarInput from '@/components/newAvtarUploader';
import ChevronDownIcon from 'vue-material-design-icons/ChevronDown.vue';
import ChevronUpIcon from 'vue-material-design-icons/ChevronUp.vue';
// import CameraIcon from "@/components/icons/IconCamera";

export default {
	components: {
		//PencilOutlinedIcon,
		EditIcon,
		IconShop,
		LogoutIcon,
		IconLaptop,
		ChevronDownIcon,
		ChevronUpIcon,
		IconHome,
		IconCommute,
		IconClipboardText,
		UserIcon,
		avtarInput
		// CameraIcon
	},
	props: {
		activeNavigation: {
			type: String,
			default: 'dashboard'
		}
	},
	data() {
		return {
			numMsgUnread: 0,
			profileUser: localStorage.getItem('user_profile')
				? JSON.parse(localStorage.getItem('user_profile'))
				: null,
			avatarNew: null,
			saving: false,
			saved: false,
			avatar: null
		};
	},
	computed: {
		...mapGetters('UserController', ['userProfile']),
		// ...mapState("ListingDetailController", [
		//   "showRejectAcceptButton"
		// ])
		isActive() {
			if (this.$route.params.screen) {
				return this.$route.params.screen;
			} else {
				return this.activeNavigation;
			}
		}
	},
	mounted() {
		if (this.userProfile) {
		}
		this.getAvatarUser();
	},
	watch: {
		userProfile: function(val) {
			if (val) {
			}
		}
	},
	methods: {
		...mapActions('UserController', [ 'UPLOAD_AVARTA_USER']),
		clickNavigate(name, category = null) {
			if (category) {
				// stop if clicked on the same caterory
				if (category === this.$route.params.screen) {
					return;
				} else {
					this.$router.push(`${this.$i18nRoute({ name: name })}${category}`);
				}
			} else if (window.location.pathname != this.$i18nRoute({ name: name })) {
				this.$router.push(this.$i18nRoute({ name: name }));
			}
		},
		userLogout() {
			this.$root.signOut();
		},
		uploadImage() {
			this.saving = true;
			setTimeout(() => this.savedAvatar(), 1000);
		},
		savedAvatar() {
			this.saving = false;
			this.saved = true;
		},
		getAvatarUser() {
			if (localStorage && localStorage.getItem('user_profile')) {
				let avatar_url = JSON.parse(localStorage.getItem('user_profile'))
					.profile_image;
				if (avatar_url) {
					this.avatar = avatar_url;
				} else {
					this.avatar = '/images/avatar.png';
				}
			}
		}
	}
};
</script>

<style lang="scss">
@import 'adsDashboardNavigate.scss';
</style>
